// extracted by mini-css-extract-plugin
export var animationContainer = "_di-0";
export var asteriskIcon = "_di-8";
export var conversationLeftSection = "_di-4";
export var conversationListItem = "_di-3";
export var conversationMiddleSection = "_di-5";
export var conversationRightSection = "_di-6";
export var detailsContent = "_di-1";
export var listContainer = "_di-7";
export var modalContent = "_di-2";